module.exports = __webpack_public_path__ + "img/about-2.49fadb4.jpg";